module.exports = __webpack_public_path__ + "img/about.5799b3b2.jpeg";